import { render, staticRenderFns } from "./ApplicationViewUriDetails.vue?vue&type=template&id=d9955028&"
import script from "./ApplicationViewUriDetails.vue?vue&type=script&lang=js&"
export * from "./ApplicationViewUriDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports